// src/firebase.js — DJ School Privilege
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDjAKFrpJJmHwVVe_mYOxUh5mQMWCXvCeU",
  authDomain: "privilege-booking.firebaseapp.com",
  projectId: "privilege-booking",
  storageBucket: "privilege-booking.firebasestorage.app",
  messagingSenderId: "731748480877",
  appId: "1:731748480877:web:9a1b4f109fd0461563cc64"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
